import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {QueryFilterAction} from '../../../../interfaces/query-filter-action.interface';
import {TorchQueryFilter} from '../../../../../../../../@backend/modules/@filters/torch-query-filter.model';

@Component({
  selector: 'app-query-filter-actions',
  templateUrl: './query-filter-actions.component.html',
  styleUrls: ['./query-filter-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QueryFilterActionsComponent {

  @Input()
  queryFilter: TorchQueryFilter;

  @Output()
  actionClicked = new EventEmitter<QueryFilterAction>(true);

  showDeleteConfirm = false;

  edit() {
    this.actionClicked.emit({
      type: 'EDIT',
      queryFilter: this.queryFilter
    });
  }

  delete() {
    this.showDeleteConfirm = false;
    this.actionClicked.emit({
      type: 'DELETE',
      queryFilter: this.queryFilter
    });
  }

  deleteToggle() {
    this.showDeleteConfirm = true;
  }

  downloadFilter() {
    const strippedFilter = Object.assign({}, this.queryFilter);
    strippedFilter.username = null;
    strippedFilter.lastModified = null;

    const blobFilter = new Blob([btoa(JSON.stringify(strippedFilter))], { type: 'text/plain'});
    const downloadFilterLink = document.createElement('a');
    const filterFileName = `${this.queryFilter.displayName.toLowerCase().replace(/\s+/g, '-')}.tqf`;

    downloadFilterLink.href = window.URL.createObjectURL(blobFilter);
    downloadFilterLink.setAttribute('download', filterFileName);

    document.body.appendChild(downloadFilterLink);
    downloadFilterLink.click();
    downloadFilterLink.remove();
  }
}
